module.exports = __webpack_public_path__ + "img/horizontal_3_7_1.fb2cb1cb.png";